import { addRules } from "Components/form/validate-methods";

window.passwordModalLoaded = function ($modal) {
    if (!$modal.hasClass("in")) {
        return;
    }

    $modal.addClass("is-loaded");

    const formElem = $modal[0].querySelector(".js-form-reset-password");

    formElem.querySelectorAll(".js-toggle-password").forEach((passToggle) => {
        passToggle.addEventListener("click", (event) => {
            const input = event.currentTarget
                .closest(".c-form__item")
                .querySelector(".c-form__input");
            const type = input.getAttribute("type");

            input.setAttribute("type", type == "text" ? "password" : "text");
        });
    });

    if (formElem) {
        $(formElem).validate({
            submitHandler: function (form) {
                $(formElem).find('button[type="submit"]').addClass("is-loading");

                $(formElem)
                    .find(".js-form-msg")
                    .removeClass("c-msg--error c-msg--success")
                    .slideUp(100);

                Form.ajaxPost(
                    form,
                    function (data) {
                        if (!data.status) {
                            $(formElem)
                                .find(".js-form-msg")
                                .addClass("c-msg--error")
                                .text(data.message)
                                .slideDown(250);
                        } else {
                            Eshop.alert(data.message);
                            $modal.modal("hide");
                        }

                        $(form).find('button[type="submit"]').removeClass("is-loading");
                    },
                    "json"
                );
            },
        });

        addRules(formElem, ["password", "password_repeat"]);
    }
};
